const DEFAULT_PADDING_RATIO = 0.05;
const ZERO_RANGE_PADDING_RATIO = 0.005;
const MIN_ABSOLUTE_PADDING = 1;

const clampPaddingToAvoidZero = (min, max, paddedMin, paddedMax) => {
    if (min > 0 && paddedMin <= 0) {
        return { min: min * (1 - DEFAULT_PADDING_RATIO), max: paddedMax };
    }
    if (max < 0 && paddedMax >= 0) {
        return { min: paddedMin, max: max * (1 - DEFAULT_PADDING_RATIO) };
    }
    return { min: paddedMin, max: paddedMax };
};

export const getPaddedDomain = (values = []) => {
    const numericValues = values.filter((value) => Number.isFinite(value));
    if (numericValues.length === 0) {
        return [0, 0];
    }

    const min = Math.min(...numericValues);
    const max = Math.max(...numericValues);

    if (min === max) {
        const basePadding = Math.abs(min) * ZERO_RANGE_PADDING_RATIO;
        const padding = Math.max(basePadding, MIN_ABSOLUTE_PADDING);
        const paddedMin = min - padding;
        const paddedMax = max + padding;
        const clamped = clampPaddingToAvoidZero(min, max, paddedMin, paddedMax);
        return [clamped.min, clamped.max];
    }

    const range = max - min;
    const padding = range * DEFAULT_PADDING_RATIO;
    const paddedMin = min - padding;
    const paddedMax = max + padding;
    const clamped = clampPaddingToAvoidZero(min, max, paddedMin, paddedMax);
    return [clamped.min, clamped.max];
};
